import React from 'react';
import { cn } from 'App/shadcn/lib/utils';
import prospectingAgentStyles from '../ProspectingAgent/prospectingAgentStyles';
import workspaceStyles from './workspaceStyles';

/**
 * Hosts a V1 Prospecting Agent view - the dossier, the run detail, the plan
 * review, the settings - inside the V2 workspace (WEB-10886).
 *
 * Those views are styled by `prospectingAgentStyles`, whose variables hang off
 * `.pa-app`, and `.pa-app` is also the V1 page's own two-column grid. So the
 * wrapper carries the class for the variables and undoes the layout, and the
 * `variant` names which of the design's surfaces the view is standing in for,
 * so `workspaceStyles` can give it the design's values. Nothing about the
 * views themselves changes: what moves is where they are shown.
 */

export type EmbedVariant = 'dossier' | 'run' | 'plan';

/** Injected once per shadow root, next to the V2 sheet. */
export const legacySheet = prospectingAgentStyles + workspaceStyles;
export const LegacyStyles = () => <style>{legacySheet}</style>;

const LegacyEmbed = ({
	children,
	variant,
	className
}: {
	children: React.ReactNode;
	variant?: EmbedVariant;
	className?: string;
}) => <div className={cn('pa-app pw-embed', variant && `pw-${variant}`, className)}>{children}</div>;

export default LegacyEmbed;
